<template>
	<div class="vs-form">
		<div class="vs-section">
			<div class="vos-content">
				<div>
					<div class='column has-text-centered'>
						<figure class="image vos-logo">
							<img src="../../assets/images/lango.png">
						</figure>
						<h1 class="subtitle is-1">Verification of Service (VOS) Form</h1>
					</div>
				</div>

				<div v-if="guest" class="guest">

					<VosFields 
						:digitalForm="digitalForm" 
						:emailCopy="true" 
						@update="update" 
						@setVariable="setVariable" />

					<div style="margin-bottom: 45px;">
						<ul class="center-button">
							<li class="save-button">
								<button v-on:click="save" type="button" class='button is-small is-link save-vos'
									v-bind:class="{ 'is-loading': saveLoader }" :disabled="!canSave">Submit</button>
								<p v-if="!canSubmitServer" style="color:red; padding-top: 5px;">There's an error submitting, please check the form and try again.</p>
							</li>
						</ul>
						<div v-if="timeNotAllowed" class="signature-support" style="padding: 10px;">
							<span class="is-danger">
								Sorry, you cannot submit this VOS yet because the job date and time have yet to start.
							</span>
						</div>
					</div>
				</div>

				<div v-if="invalidToken" class="invalid">
					<div class="password-reset" style="margin-bottom: 25px;">
						<p style="margin-bottom: 10px;"><img src="../../assets/images/error.png" /></p>
						<p class="au-title">Job Not Found</p>
						<br />
						<p class="au-message">
							The server cannot locate this job, please use the link found in purchase order.
						</p>
					</div>
				</div>

				<div v-if="alreadyUploaded" class="already-upload">
					<div class="password-reset" style="margin-bottom: 25px;">
						<p style="margin-bottom: 10px;"><img src="../../assets/images/caution.png" /></p>
						<p class="au-title">VOS Submitted</p>
						<br />
						<p class="au-message">
							Looks like you have aleady submitted VOS for this job. Thank you!
						</p>
					</div>
				</div>

				<div v-if="uploadSuccess" class="success">
					<div class="password-reset" style="margin-bottom: 25px;">
						<p style="margin-bottom: 10px;"><img src="../../assets/images/success.png" /></p>
						<p class="au-title">VOS Successfully Submitted</p>
						<br />
						<p class="au-message">
							Thank you for submitting your VOS for job {{ digitalForm.job_no }}.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import VosFields from "@/reusable_components/VosFieldsComponent";

export default {
	components: {
		VosFields
	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters("requestVos", {
			selectedFile: "getSelectedFile",
			digitalForm: "getdigitalFormData",
			canSave: "getcanSave",
			saveLoader: "getsaveLoader"
		}),

		...mapState("requestVos", {
			alreadyUploaded: state => state.alreadyUploaded,
			invalidToken: state => state.invalidToken,
			uploadSuccess: state => state.uploadSuccess,
			guest: state => state.guest,
			timeNotAllowed: state => state.timeNotAllowed,
			canSubmitServer: state => state.canSubmitServer,

		})
	},
	methods: {
    update(key, value) {
      // dispatch action to update vuex
      VueStore.dispatch("requestVos/updateSelectedData", {
        key: key,
        value: value
      });
    },
    setVariable(key, value) {
      VueStore.dispatch("requestVos/setVariable", {
        key: key,
        value: value
      });
    },
    close() {
      VueStore.dispatch("notify/setShowMessage", {
        key: "viewDigitalVosModal",
        bool: false
      });
    },
    save() {
      if (this.canSave) {
        VueStore.dispatch("requestVos/saveDigital");
        //VueStore.dispatch("requestActual/create");
      }
    },
		prcoessURL() {
			var url_string = window.location.href;
			var url = new URL(url_string);
			var token = url.searchParams.get("token");
			var id = url.searchParams.get("id");

			if (token !== null && id !== null) {
				var data = {
					token: token,
					id: id
				};

				// we'll save token for later usage
				VueStore.dispatch("requestVos/setVariable", {
					key: "data",
					value: data
				});

				// delay so auth store is loaded.
				setTimeout(function () {
					VueStore.dispatch("requestVos/checkToken", data);
				}, 500);
			} else {
				// show job not available
				VueStore.dispatch("requestVos/setVariable", {
					key: "invalidToken",
					value: true
				});
			}
		}
	},

	mounted() {
		//this.fetchData();
		this.prcoessURL();
		// retrive environment variables and stored in vuex.
		VueStore.dispatch("auth/setVariables");
	}
};
</script>
<style>
html {
	overflow-y: hidden !important;
}

body {
	position: relative !important;
	overflow: auto !important;
	background-color: #fff !important;
}

span.is-danger {
	color: red;
}

/* Lango logo (src is 291x110) — keep it centered and let it shrink on
   narrow screens instead of forcing horizontal scroll. */
.vos-logo {
	margin: 0 auto 15px;
}

.vos-logo img {
	display: block; /* Bulma's .image already does this; re-asserted here because the block display is what breaks text-align centering */
	margin: 0 auto;
	width: 180px;
	max-width: 100%;
	height: auto;
}

.padded-bottom-border {
	padding-bottom: 10px !important;
}

.gray-bg label,
.cancelled-bg label {
	margin-top: 5px !important;
}

li.save-button {
	padding: 10px;
}

input[type="text"],
input[type="search"],
input[type="password"] {
	-webkit-box-shadow: inset 1px 1px 3px rgb(0 0 0 / 18%) !important;
	border-radius: 0 !important;
	border: none !important;
	font-size: 14px;
	border: 1px solid #cfd4d8;
	background-color: #fff;
}

/* smartphones, iPhone, portrait 480x320 phones.
   Only page-specific rules here: global selectors (label, input, .control,
   #app, html, body, ...) previously leaked into every other page below
   1280px and conflicted with the app's responsive styles. Form-field
   responsive styles live in VosFieldsComponent (scoped). */
@media only screen and (max-width: 1280px) {
	.vs-form {
		margin: 0 !important;
	}

	.vos-title {
		font-size: 2.5em;
		font-weight: bold;
		margin-top: 5px;
	}

	/* No fixed width on phones — the form fills the viewport with a
	   16px gutter instead of the old min-width: 400px which forced
	   horizontal scrolling on every phone. */
	.vs-form {
		min-width: 0 !important;
		width: auto !important;
		background: #fff !important;
		height: auto;
		padding: 0 16px;
	}

	.subtitle {
		font-weight: bold;
		font-size: 1.5em;
		margin-bottom: 10px;
	}

	.save-vos {
		font-size: 2em !important;
		width: 100% !important;
		height: 80px !important;
		border-radius: 10px !important;
	}

	.signature-support {
		font-size: 26px !important;
	}

	.center-button {
		display: block !important;
	}

	.jSignature {
		height: 300px !important;
	}

	.au-title {
		font-size: 1.5em;
		font-weight: bold;
	}

	.au-message {
		font-size: 1.5em;
	}
}

/* hi-res laptops and desktops */
@media (min-width: 1281px) {
	.vos {
		position: relative;
		margin: 0 auto;
		padding: 10px;
		background-color: #fff;
	}

	.vos-title {
		font-size: 1.5rem;
		font-weight: bold;
		margin-top: 5px;
	}

	.vs-form {
		width: 900px !important;
		background: #fff !important;
		margin: 0 auto !important;
	}

	.save-vos {
		font-size: 14px !important;
		width: 100px !important;
		height: 50px !important;
		border-radius: 5px !important;
	}

	.jSignature {
		height: 200px !important;
	}
}
</style>
